'use client';

import { useTranslations } from 'next-intl';
import { usePathname, useSearchParams } from 'next/navigation';
import { HeaderAccountButton } from 'components/pcc-components';
import { useLogout } from 'hooks/use-logout';
import { CatPrimaryNavItem } from 'components/blocks-components';
import { useInAppSignOut } from '@cat-ecom/pcc-components/src/hooks/useInAppSignOut';
import { useLogin } from 'hooks/use-login';
import { getModifiedLogoutURL, getCurrentPath } from './utils';

type SignOutButtonProps = {
  logoutURL: string;
  isMobileMenu?: boolean;
};

export const SignOutButton = ({
  logoutURL,
  isMobileMenu = false
}: SignOutButtonProps) => {
  const t = useTranslations();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const signOutLabel = t('HEADER_SIGN_OUT');
  const { logout } = useLogout();
  const { removeGuestCookies } = useLogin();
  const { getInAppCookie } = useInAppSignOut();

  // Construct the full current path with query parameters
  const currentPath = getCurrentPath(pathname, searchParams);

  const modifiedLogoutURL = getModifiedLogoutURL(logoutURL, currentPath);

  const signOut = () => {
    removeGuestCookies();
    logout();
  };

  if (getInAppCookie()) return null;

  return isMobileMenu ? (
    <CatPrimaryNavItem
      data-testId="signOutNavItemMobile"
      text={signOutLabel}
      onClick={signOut}
      href={modifiedLogoutURL}
      style={{
        borderBottom: '1px solid var(--cat-theme-color-border-strong-hover)'
      }}
    />
  ) : (
    <HeaderAccountButton
      label={signOutLabel}
      onClick={signOut}
      href={modifiedLogoutURL}
    />
  );
};
